module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-7-9cd65f31f5f087eef03279816bfc6ab4.jpg";